module.exports = __webpack_public_path__ + "img/Sokratis.b07edf79.png";